// extracted by mini-css-extract-plugin
export var closeButton = "hoverCardGridModal-module--closeButton--4c29f";
export var description = "hoverCardGridModal-module--description--236a8";
export var dialog = "hoverCardGridModal-module--dialog--87684";
export var hoverCardGridModalDialogSlideDown = "hoverCardGridModal-module--hoverCardGridModalDialogSlideDown--dc02b";
export var hoverCardGridModalDialogSlideUp = "hoverCardGridModal-module--hoverCardGridModalDialogSlideUp--7abdf";
export var hoverCardGridModalOverlayFadeIn = "hoverCardGridModal-module--hoverCardGridModalOverlayFadeIn--d82ac";
export var hoverCardGridModalOverlayFadeOut = "hoverCardGridModal-module--hoverCardGridModalOverlayFadeOut--541d8";
export var image = "hoverCardGridModal-module--image--65d65";
export var imageWrapper = "hoverCardGridModal-module--imageWrapper--fd125";
export var modalButton = "hoverCardGridModal-module--modalButton--82d9d";
export var modalButtonWrapper = "hoverCardGridModal-module--modalButtonWrapper--fbb2a";
export var modalContent = "hoverCardGridModal-module--modalContent--653eb";
export var overlay = "hoverCardGridModal-module--overlay--946c7";
export var title = "hoverCardGridModal-module--title--c517c";